import { type ContestDto } from './Contest';
import { ParticipantModel } from './Participant';
import { type UserDto, type UserFilters } from './User';

export type OrganizerFilters = UserFilters;

export type OrganizerDto = UserDto;

export interface OrganizerExtendedDto extends OrganizerDto {
  contests: ContestDto[];
}

export class OrganizerModel extends ParticipantModel implements Omit<OrganizerDto, 'status'> {}
